import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { GET_PARTY_STATUSES } from "../../../../../components/contract/payeeTable/constants";

interface IPartyCard {
  name?: string;
  phone: string;
  image?: string;
  amount: string;
  status?: string;
}

const PartyCard = ({ name, phone, image, amount, status }: IPartyCard) => {
  const { t } = useTranslation();
  const partiesStatuses = GET_PARTY_STATUSES(t);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.image_container}>
          <img src={image || "/assets/images/svg/user.svg"} alt="" />
        </div>
        <div className={styles.header_content}>
          <p
            className={classNames(
              !name ? styles["g400"] : "",
              styles["description"],
              styles.name
            )}>
            {name || t("lbl_not_registered_yet")}
          </p>
          <p className={classNames(styles.description, styles.phone)}>
            {phone.slice(0, 4) + " " + phone.slice(4)}
          </p>
        </div>
      </div>

      <div className={styles.content_container}>
        <div className={styles.content}>
          <div className={styles.data_container}>
            <p className={styles.title}>{t("lbl_bank_amount")}</p>
            <p className={styles.description}>
              {amount + " " + t("lbl_saudi_currency")}
            </p>
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.data_container}>
            <p className={styles.title}>{t("lbl_condition")}</p>
            <span
              className={styles.statusPill}
              style={{
                background: partiesStatuses?.[String(status)]?.color,
              }}>
              <p
                style={{
                  color: partiesStatuses?.[String(status)]?.textColor,
                }}>
                {partiesStatuses?.[String(status)]?.title}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartyCard;
